export default __webpack_public_path__ + "static/media/telegram.78814a8e.svg";